import getEnvironmentConfiguration from '@/config'
import axios from 'axios'

export class APIClient {
  constructor () {
    const config = getEnvironmentConfiguration()
    this.API_URL = config.REACT_APP_MEDIA_API_URL || 'https://media.boxes-dev.link'
    if (process.env.REACT_APP_TEST_API) { this.API_URL = 'http://localhost:5001' }
    this.axios = axios
    this.logged = false
  }

  get (url) {
    return new Promise((resolve, reject) => {
      this.axios.get(`${this.API_URL}/${url}`)
        .then(response => resolve(response))
        .catch(error => reject(error.response))
    })
  }

  post (url, params) {
    return new Promise((resolve, reject) => {
      this.axios.post(`${this.API_URL}/${url}`, params)
        .then(response => resolve(response))
        .catch(error => reject(error.response))
    })
  }

  put (url, params) {
    return new Promise((resolve, reject) => {
      this.axios.put(`${this.API_URL}/${url}`, params)
        .then(response => resolve(response))
        .catch(error => reject(error.response))
    })
  }

  delete (url) {
    return new Promise((resolve, reject) => {
      this.axios.delete(`${this.API_URL}/${url}`)
        .then(response => resolve(response))
        .catch(error => reject(error.response))
    })
  }

  setUpUserIdHeader (userId) {
    this.axios.defaults.headers['X-User-ID'] = userId
  }

  controlStatusFnct (res, error) {
    if (res.status === 401 && !(process.env.TEST_API || process.env.TEST)) {
      window.localStorage.clear()
      window.location.reload()
    } else {
      throw new Error(error)
    }
  }
}

export const MediaAPI = new APIClient()
